var React = require('react');

function Scroll (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M36 0C16.1178 0 0 16.1178 0 36H72C72 16.1178 55.8823 0 36 0Z","fill":"#FFF8F0","fillOpacity":"0.5","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M36.7841 23.7552C36.3984 24.1209 35.7939 24.1209 35.4082 23.7552L29.0618 17.7389C28.6904 17.3868 28.1084 17.3868 27.737 17.7389C27.3365 18.1186 27.3365 18.7566 27.737 19.1363L35.4082 26.4085C35.7939 26.7742 36.3984 26.7742 36.7841 26.4085L44.4553 19.1363C44.8558 18.7566 44.8558 18.1186 44.4553 17.7389C44.0839 17.3868 43.5019 17.3868 43.1306 17.7389L36.7841 23.7552Z","fill":"#3A3A3A","key":1})]);
}

Scroll.defaultProps = {"width":"72","height":"36","viewBox":"0 0 72 36","fill":"none"};

module.exports = Scroll;

Scroll.default = Scroll;
